// extracted by mini-css-extract-plugin
module.exports = {"root":"_3WK-i","header":"_3kHbP","selectPlanTitle":"_3pvyk","plans":"_2wLly","plan":"_1hMXy","compareButton":"_3nTsU","actualSavings":"_1zG-t","upperCaseLink":"_3iKlt"};